const messages = {
  en: {
    translations: {
      pages: {
        agents: {
          title: "Assistants",
          labels: {
            edit: "Edit",
            del: "Delete",
            name: "Name",
            model: "Model",
            visibility: "Visibility",
            createdAt: "Created At",
            actions: "Actions",
            functions: "Functions",
            createFunction: "Create Function",
            notFoundFc: "No function found.",
            error: {
              createAgent: "Oops! Error creating new assistant.",
              updateAgent: "Oops! Error updating assistant.",
              deleteAgent: "Oops! Error deleting assistant.",
              createFunction: "Oops! Error creating function.",
              deleteFunction: "Oops! Error deleting function.",
              updateFunction: "Oops! Error updating function."
            },
            success: {
              createAgent: "Assistant created successfully.",
              updateAgent: "Assistant updated successfully.",
              deleteAgent: "Assistant deleted successfully.",
              createFunction: "Function created successfully.",
              deleteFunction: "Function deleted successfully.",
              updateFunction: "Function updated successfully.",
              confirmFunction: "Are you sure you want to delete the function?"
            }
          },
          modalFunctions: {
            title: "Create Custom Function",
            type: "Type",
            name: "Name",
            description: "Description",
            properties: "Properties",
            method: "Method",
            url: "URL",
            accept: "Accept",
            httpRequest: "HTTP Request",
            value: "Value",
            key: "Key",
            close: "Close",
            headers: "Headers",
            required: "Required",
            openDescription: "Open description in full screen",
            updateFunction: "Update Function",
            save: "Save",
            labels: {
              required: {
                name: "Name is required.",
                description: "Description is required.",
                type: "Type is required.",
                method: "Method is required.",
                url: "Enter a valid URL.",
                headers: "Header is required.",
                properties: "Properties are required."
              }
            },
            types: {
              string: "Text",
              integer: "Integer",
              number: "Number",
              boolean: "Boolean",
              object: "Object",
              array: "List",
              audio: "Audio",
              video: "Video",
              image: "Image",
              document: "File"
            },
            select: {
              audio: "Select audio",
              video: "Select video",
              image: "Select image",
              document: "Select file"
            },
            attached: {
              audio: "Attached audio",
              video: "Attached video",
              image: "Attached image",
              document: "Attached file"
            }
          },
          modal: {
            close: "Close",
            openInstructions: "Open instructions in full screen",
            title: "Create New Assistant",
            subtitle: "Configure your AI assistant's properties",
            editTitle: "Edit Assistant",
            editSubtitle: "Update the assistant's properties",
            name: "Assistant Name",
            description: "Description (optional)",
            instructions: "Instructions",
            instructionsHelper:
              "Describe how the assistant should behave and respond",
            model: "Model",
            tools: "Tools",
            toolsHelper: "Select the tools the assistant can use",
            responseFormat: "Response Format",
            temperature: "Temperature",
            topP: "Top P",
            metadata: "Metadata",
            category: "Category",
            version: "Version",
            btn: "Create Assistant",
            btnEdit: "Update Assistant",
            confirmAgent: "Are you sure you want to delete the assistant?",
            codeInterpreter: "Code Interpreter",
            webSearch: "Web Search",
            tone: "Conversation Tone",
            style: "Response Style",
            maxTokens: "Token Limit",
            visibility: "Visibility",
            private: "Private",
            public: "Public",
            tones: {
              toneFormal: "Formal",
              toneInformal: "Informal",
              toneFriendly: "Friendly",
              toneProfessional: "Professional",
              toneMotivational: "Motivational",
              toneEmpathetic: "Empathetic",
              toneHumorous: "Humorous"
            },
            styles: {
              styleBrief: "Short",
              styleDetailed: "Detailed",
              styleTechnical: "Technical",
              styleCreative: "Creative",
              styleSummary: "Summary",
              styleList: "List",
              styleConversational: "Conversational"
            }
          },
          techProvider: {
            title: "WhatsApp Review",
            subtitle: "Manage templates, sync the webhook, and monitor sending and receiving for the configured number.",
            alerts: {
              configure: "Set WHATSAPP_TEST_PHONE_NUMBER_ID, WHATSAPP_TEST_TOKEN, and WHATSAPP_TEST_WABA in the backend to unlock this page.",
              validationError: "Could not validate the configured phone_number_id:"
            },
            common: {
              configured: "Configured",
              pending: "Pending",
              refresh: "Refresh",
              refreshing: "Refreshing...",
              sending: "Sending...",
              loading: "loading...",
              notAvailable: "N/A",
              status: "Status",
              noStatus: "no status",
              contact: "Contact",
              template: "Template",
              you: "You"
            },
            categories: {
              utility: "Utility",
              marketing: "Marketing",
              authentication: "Authentication"
            },
            stats: {
              phoneNumberId: "Phone Number ID",
              waba: "WABA",
              templates: "Templates",
              webhook: "Webhook",
              visibleNumber: "Visible number",
              waitingApproval: "{{count}} waiting for approval"
            },
            webhook: {
              title: "Webhook sync",
              description: "Use this step before send/receive tests to make sure the test WABA points to this backend.",
              sync: "Sync webhook",
              syncing: "Syncing...",
              subscribedApps: "Subscribed apps right now: {{count}}",
              appWithoutName: "Unnamed app"
            },
            templateCreate: {
              title: "1. Submit template for approval",
              description: "Build a simple template without variables to speed up the review.",
              open: "Open template creation",
              name: "Template name",
              nameHelper: "Use lowercase letters, numbers, and underscores.",
              category: "Category",
              language: "Language",
              header: "Header (optional)",
              body: "Template body",
              footer: "Footer (optional)",
              submit: "Submit for approval"
            },
            templateSend: {
              title: "2. Send approved template",
              description: "Use the name of an approved template and the destination number to validate the send flow.",
              open: "Open template send",
              to: "Destination (with country code)",
              templateName: "Template name",
              language: "Template language",
              bodyParameters: "Body parameters (1 per line, optional)",
              submit: "Send template"
            },
            chat: {
              title: "3. Real-time test chat",
              description: "Open the chat to follow messages and live statuses through the socket.",
              target: "Destination number (country code + phone only)",
              targetHelper: "The backend automatically normalizes the value to the format accepted by Meta.",
              socketConnected: "Socket connected",
              socketDisconnected: "Socket disconnected",
              talkingTo: "Talking to {{target}}",
              defineTarget: "Set the destination number to open the filtered conversation.",
              open: "Open chat",
              refreshHistory: "Refresh history"
            },
            templates: {
              title: "Available templates",
              description: "Click use to automatically fill the send form.",
              use: "Use this template",
              empty: "No templates were returned for this WABA.",
              noCategory: "No category",
              noLanguage: "No language",
              noVisibleBody: "No visible body"
            },
            logs: {
              title: "WhatsApp logs",
              description: "Events sent by the backend and messages captured through the test number webhook.",
              open: "View logs",
              clear: "Clear",
              empty: "No events yet. After you send a template or message, the logs will appear here and keep updating."
            },
            chatModal: {
              title: "Test number chat",
              description: "Real-time sending and receiving with Socket.IO.",
              socketOnline: "Socket online",
              socketOffline: "Socket offline",
              destination: "Destination number",
              destinationHelper: "Use country code + number. The backend removes punctuation, spaces, and the + sign.",
              noVisibleText: "Message without visible text",
              empty: "No messages yet for this destination. Send a message and reply through WhatsApp to validate the flow.",
              message: "Message",
              send: "Send message",
              reload: "Reload events"
            },
            feedback: {
              success: {
                syncWebhook: "Test number webhook synchronized.",
                templateCreated: "Template submitted for approval.",
                templateSent: "Template sent to the informed number.",
                messageSent: "Message sent.",
                logsCleared: "History cleared."
              },
              errors: {
                loadConfig: "Error loading the test number configuration.",
                loadTemplates: "Error listing templates.",
                loadApps: "Error listing subscribed apps.",
                syncWebhook: "Error syncing the webhook.",
                createTemplate: "Error submitting template for approval.",
                sendTemplate: "Error sending template.",
                sendMessage: "Error sending message.",
                clearLogs: "Error clearing history."
              }
            }
          }
        },
        whatsapp: {
          title: "WhatsApp",
          activation: {
            title: "Activate number",
            subtitle: "Provide the WABA, load the available numbers, request the code by SMS or voice, and finish activation in the Cloud API.",
            wabaId: "WABA ID",
            wabaIdHelper: "This page uses the Embedded connection already stored to query numbers in Meta.",
            loadNumbers: "Load numbers",
            loadingNumbers: "Loading numbers...",
            noNumbers: "No phone numbers were returned for this WABA.",
            columns: {
              number: "Number",
              verifiedName: "Verified name",
              quality: "Quality",
              codeStatus: "Code status",
              actions: "Actions"
            },
            status: {
              pending: "Pending",
              requestCode: "Request code",
              requestAgain: "Request again",
              requesting: "Requesting...",
              register: "Register number",
              registering: "Registering...",
              loadSuccess: "Numbers loaded successfully.",
              requestSuccess: "Code requested successfully.",
              registerSuccess: "Number successfully activated in the Cloud API."
            },
            activity: {
              title: "Activity",
              subtitle: "Latest load and activation events.",
              empty: "Actions performed on this page will appear here.",
              success: "Success",
              error: "Error"
            },
            modal: {
              title: "Activate number",
              subtitle: "Choose the delivery method and finish activation.",
              method: "Delivery method",
              sms: "SMS",
              voice: "VOICE",
              verificationCode: "Verification code",
              verificationCodeHelper: "Enter the code received on the selected number.",
              selectedNumber: "Selected number",
              requestCode: "Request code",
              close: "Close"
            },
            feedback: {
              loadError: "Error listing the WABA numbers.",
              requestError: "Error requesting the verification code.",
              registerError: "Error registering the number in the Cloud API.",
              missingWaba: "Provide the WABA ID to continue.",
              selectNumber: "Select a number to continue."
            }
          },
          techProvider: {
            title: "WhatsApp Review",
            subtitle: "Manage templates, sync the webhook, and monitor sending and receiving for the configured number.",
            alerts: {
              configure: "Set WHATSAPP_TEST_PHONE_NUMBER_ID, WHATSAPP_TEST_TOKEN, and WHATSAPP_TEST_WABA in the backend to unlock this page.",
              validationError: "Could not validate the configured phone_number_id:"
            },
            common: {
              configured: "Configured",
              pending: "Pending",
              refresh: "Refresh",
              refreshing: "Refreshing...",
              sending: "Sending...",
              loading: "loading...",
              notAvailable: "N/A",
              status: "Status",
              noStatus: "no status",
              contact: "Contact",
              template: "Template",
              you: "You"
            },
            categories: {
              utility: "Utility",
              marketing: "Marketing",
              authentication: "Authentication"
            },
            stats: {
              phoneNumberId: "Phone Number ID",
              waba: "WABA",
              templates: "Templates",
              webhook: "Webhook",
              visibleNumber: "Visible number",
              waitingApproval: "{{count}} waiting for approval"
            },
            webhook: {
              title: "Webhook sync",
              description: "Use this step before send/receive tests to make sure the test WABA points to this backend.",
              sync: "Sync webhook",
              syncing: "Syncing...",
              subscribedApps: "Subscribed apps right now: {{count}}",
              appWithoutName: "Unnamed app"
            },
            templateCreate: {
              title: "1. Submit template for approval",
              description: "Build a simple template without variables to speed up the review.",
              name: "Template name",
              nameHelper: "Use lowercase letters, numbers, and underscores.",
              category: "Category",
              language: "Language",
              header: "Header (optional)",
              body: "Template body",
              footer: "Footer (optional)",
              submit: "Submit for approval"
            },
            templateSend: {
              title: "2. Send approved template",
              description: "Use the name of an approved template and the destination number to validate the send flow.",
              to: "Destination (with country code)",
              templateName: "Template name",
              language: "Template language",
              bodyParameters: "Body parameters (1 per line, optional)",
              submit: "Send template"
            },
            chat: {
              title: "3. Real-time test chat",
              description: "Open the chat to follow messages and live statuses through the socket.",
              target: "Destination number (country code + phone only)",
              targetHelper: "The backend automatically normalizes the value to the format accepted by Meta.",
              socketConnected: "Socket connected",
              socketDisconnected: "Socket disconnected",
              talkingTo: "Talking to {{target}}",
              defineTarget: "Set the destination number to open the filtered conversation.",
              open: "Open chat",
              refreshHistory: "Refresh history"
            },
            templates: {
              title: "Available templates",
              description: "Click use to automatically fill the send form.",
              use: "Use this template",
              empty: "No templates were returned for this WABA.",
              noCategory: "No category",
              noLanguage: "No language",
              noVisibleBody: "No visible body"
            },
            logs: {
              title: "WhatsApp logs",
              description: "Events sent by the backend and messages captured through the test number webhook.",
              open: "View logs",
              clear: "Clear",
              empty: "No events yet. After you send a template or message, the logs will appear here and keep updating."
            },
            chatModal: {
              title: "Test number chat",
              description: "Real-time sending and receiving with Socket.IO.",
              socketOnline: "Socket online",
              socketOffline: "Socket offline",
              destination: "Destination number",
              destinationHelper: "Use country code + number. The backend removes punctuation, spaces, and the + sign.",
              noVisibleText: "Message without visible text",
              empty: "No messages yet for this destination. Send a message and reply through WhatsApp to validate the flow.",
              message: "Message",
              send: "Send message",
              reload: "Reload events"
            },
            feedback: {
              success: {
                syncWebhook: "Test number webhook synchronized.",
                templateCreated: "Template submitted for approval.",
                templateSent: "Template sent to the informed number.",
                messageSent: "Message sent.",
                logsCleared: "History cleared."
              },
              errors: {
                loadConfig: "Error loading the test number configuration.",
                loadTemplates: "Error listing templates.",
                loadApps: "Error listing subscribed apps.",
                syncWebhook: "Error syncing the webhook.",
                createTemplate: "Error submitting template for approval.",
                sendTemplate: "Error sending template.",
                sendMessage: "Error sending message.",
                clearLogs: "Error clearing history."
              }
            }
          },
          inbox: {
            title: "Chats",
            labels: {
              noConversations: "No conversations",
              noConversationsFound: "No conversations found",
              tryDifferentSearch: "Try searching with different terms",
              startNewConversation: "Your conversations will appear here",
              writeAddress:
                "Enter an address or coordinates (latitude, longitude)",
              sendContact: "Send contact",
              newMessageReceive: "New message available",
              hideContent: "Hide caption",
              showContent: "Show caption",
              renameContact: "Rename contact",
              cancel: "Cancel",
              enableAgent: "Enable bot",
              conversations: "Chats",
              disconnect: "Disconnect",
              edit: "Edit",
              loadConversations: "Loading chats",
              searchContact: "Search contact",
              menu: "Menu",
              moreOptions: "More options",
              all: "All",
              sendNewMessage: "Send new message",
              favorites: "Favorites",
              search: "Search chat",
              find: "Find",
              dataContact: "Contact details",
              addFavorites: "Add to favorites",
              removeFavorites: "Remove from favorites",
              closeChat: "Close chat",
              findItem: "Search messages",
              message: "Message",
              turnOff: "Turn off",
              copy: "Copy",
              options: "Options",
              download: "Download",
              messageNotFound: "No messages found.",
              attach: "Attach",
              send: "Send",
              record: "Record",
              writeMessage: "Type a message",
              deleteRecord: "Delete",
              pause: "Pause",
              play: "Play",
              files: "Files",
              audio: "Audio",
              camera: "Camera",
              contact: "Contact",
              disableAgent: "Disable bot",
              writePhone: "Enter the phone number",
              phone: "Phone",
              sending: "Sending",
              notFoundChat: "Select a chat to start sending messages.",
              confirmLocation: "Confirm your location",
              addCaption: "Add a caption",
              save: "Save",
              name: "Name",

              attachments: {
                document: "Document",
                video: "Video",
                location: "Location",
                contact: "Contact",
                photos: "Photos",
                photo: "Photo",
                audio: "Audio"
              },

              success: {
                sendLocation: "Location sent successfully.",
                sendContact: "Contact sent successfully.",
                sendMessage: "Message sent successfully.",
                copy: "Text copied successfully.",
                enableBot: "Bot enabled successfully.",
                disableBot: "Bot disabled successfully.",
                renameContact: "Contact renamed successfully."
              },

              error: {
                sendMessage: "Oops! Error sending the message.",
                sendDocument: "Oops! Error sending the file.",
                sendContact: "Oops! Error sending the contact.",
                sendLocation: "Oops! Error sending the location.",
                typeNotAllowed: "File type not allowed.",
                bot: "Oops! Error enabling/disabling the bot.",
                authorizeLocation: "Please authorize location access.",
                audio: "There was an error processing your audio.",
                renameContact: "Oops! Error renaming the contact.",
                getLocation: "Oops! Error fetching location."
              },

              required: {
                message: "Message is required.",
                number: "Contact number is required.",
                imageUrl: "Please select a valid image.",
                audioUrl: "There was an error processing your audio.",
                documentUrl: "Please select a valid document.",
                videoUrl: "There was an error processing your video.",
                contactPhone: "Please select a valid contact.",
                nameLocation: "Location name is required.",
                addressLocation: "Location address is required.",
                lat: "Latitude is required.",
                long: "Longitude is required.",
                name: "Contact name is required."
              }
            }
          },
          connections: {
            title: "Connections",
            labels: {
              modal: {
                connectWhats: "Connect WhatsApp",
                scannerText: "Scan the QR code below using WhatsApp to connect",
                generateQr: "Generating QR code..."
              },
              assistant: "Assistant",
              errorWhats: "Failure",
              open: "Connected",
              connect: "Connect",
              online: "Online",
              offline: "Offline",
              pending: "Pending",
              connecting: "Connecting",
              openChat: "Open Chat",
              closeConnection: "Close Connection",
              reconnect: "Reconnect",
              newConnection: "New connection",
              edit: "Edit",
              delete: "Delete",
              notFound: "No connections found.",
              create: "New connection",
              update: "Update connection",
              name: "Name",
              add: "Add",
              save: "Save",
              close: "Closed",
              required: {
                name: "Name is required.",
                userId: "User ID is required."
              },
              error: {
                create: "Oops! Error creating connection.",
                update: "Oops! Error updating connection.",
                delete: "Oops! Error deleting connection.",
                connected: "A connection was closed.",
                reconnect: "Oops! Error reconnecting."
              },
              success: {
                create: "Connection created successfully.",
                update: "Connection updated successfully.",
                delete: "Connection deleted successfully.",
                connected: "Connection established successfully.",
                reconnect: "Please wait, reconnecting..."
              }
            }
          }
        },
        finishRegister: {
          title: "Account Registration Finalization",
          labels: {
            finishing: "Finishing...",
            finish: "Finish registration",
            titleComplete:
              "Complete your registration now and unlock a variety of amazing benefits just for you!",
            subtitleComplete:
              "Take advantage of our plans, available for a limited time! Choose the plan that best suits your goals and achieve better results!",
            selectType: "Select account type:",
            password: "Password",
            repeatPassword: "Repeat password",
            state: "State",
            city: "City",
            phone: "(Area Code) + Phone",
            address: "Address",
            addressComplement: "Address Complement",
            document: "Identification Document",
            plansTitle: "Boost your sales with these exclusive packages!",
            plansSubtitle:
              "Take advantage of our plans, available for a limited time! Choose the plan that best suits your goals and achieve better results!",
            forMonth: "per month",
            success: {
              register: "Registration successfully completed."
            },
            error: {
              register: "Oops! Error finalizing your registration."
            },
            benefits: {
              maxListings: "Up to {{count}} real estate listings",
              maxImagesPerListing: "Up to {{count}} images per listing",
              marketplace: "Marketplace for products and services",
              crmContacts: "Contact management (CRM)",
              crmNegotiations: "Negotiation management (CRM)",
              exclusiveListings:
                "Real estate listings without third-party properties",
              watermark: "Your watermark on images",
              whatsappOnProfile: "Your WhatsApp on profile and listing",
              publicProfile:
                "Public profile with your properties and social networks",
              coursesArea: "Courses area",
              propertySharingNetwork: "Property sharing network",
              personalizedSupport: "Personalized support (Helpdesk)",
              unlimitedAds: "Unlimited real estate listings",
              unlimitedPhotos: "Unlimited images per listing"
            }
          }
        },
        login: {
          title: "Login",
          subtitle:
            "Welcome! Please enter your credentials to access your account.",
          labels: {
            button: "Sign In",
            register: "Don't have an account yet?",
            forgot: "Forgot your password?",
            error: {
              sign: "Oops! Login failed. Check your credentials and try again.",
              finish: "Complete your registration.",
              signGoogle: "Error logging in with Google.",
              notExists: "Access Denied: Invalid email or password.",
              notRegister:
                "You are not registered in the system. Please sign up!"
            },
            success: {
              sign: "Login successful!"
            }
          }
        },
        register: {
          title: "Create your account on Zapps",
          subtitle: "Sign up to access exclusive features",
          labels: {
            button: "Sign Up",
            sign: "Already have an account? Log in",
            error: {
              signGoogle: "Error logging in with Google.",
              registerGoogle: "Error signing up with Google.",
              register: "Error creating an account on Zapps.",
              exists: "Account already exists, please log in."
            },
            success: {
              register:
                "Almost there! Complete your details to finish your account."
            }
          }
        },
        forgot: {
          title: "Password Recovery",
          subtitle: "Reset your password and regain access to your account.",
          labels: {
            recovery: "Recover",
            sign: "Sign In",
            sending: "Sending email...",
            success: {
              send: "Recovery email sent."
            },
            error: {
              send: "Oops! Error sending recovery link."
            }
          }
        },
        plans: {
          title: "Boost your sales with these exclusive packages!",
          subtitle:
            "Take advantage of our plans; they will be available for a limited time! Choose the plan that best suits your goals and achieve better results!",
          check: "Confirm Plan",
          checking: "Confirming...",
          labels: {
            error: {
              createSession:
                "Oops! Error confirming the plan. Check your registered information."
            }
          }
        },
        popupChange: {
          title: "Your plan is canceled",
          subtitle: "Choose a plan to continue accessing the system."
        },
        users: {
          title: "Users",
          search: "Search",
          firstname: "First Name",
          lastname: "Last Name",
          email: "E-mail",
          phone: "Phone",
          companyName: "Company Name",
          country: "Country",
          state: "State",
          city: "City",
          license: "License",
          userType: "Access type",
          name: "Full Name",
          password: "Password",
          edit: "Save",
          administrator: "Administrator",
          broker: "BROKER",
          realEstate: "REAL ESTATE",
          constructionCompany: "CONSTRUCTION COMPANY",
          btnModal: "New user",
          btnDownload: "Download",
          btnEdit: "Edit",
          btnRemove: "Del",
          btnView: "Details",
          accountType: "Account type",
          document: "Document",
          modal: {
            title: "Register a new user",
            btn: "Add"
          },
          alerts: {
            editUser: "User successfully edited.",
            incomplete: "Fill in the required fields",
            create: "User created successfully.",
            deleteConfirm: "Do you really want to delete this user?",
            deleted: "Deleted user successfully",
            error: "Try again",
            errorDel: "Error deleting user.",
            errorCreate: "Error creating user.",
            errorEdit: "Error editing user."
          },
          labels: {
            firstname: "First name is required.",
            lastname: "Last name is required.",
            password: "Password required min 6 characters.",
            name: "Full Name is required.",
            email: "The provided email is not valid.",
            phone: "Phone number is required.",
            ddi: "Country code is required.",
            creci: "License is required.",
            country: "Country is required.",
            state: "State is required.",
            city: "City is required.",
            userType: "User type is required.",
            referral: "Referrer is required.",
            notFoundData: "No data found."
          },
          access: {
            admin: "ADMINISTRATOR",
            user: "REALTOR",
            finance: "FINANCIAL",
            mkt: "MARKETING",
            construct: "CONSTRUCTION"
          }
        },
        helpDesk: {
          title: "Help Desk",
          subTitle:
            "Open a ticket and receive specialized support to find quick solutions.",
          labels: {
            priorityLow: "Low",
            priorityNormal: "Medium",
            priorityHigh: "High",
            statusOpen: "Opened",
            statusPending: "Awaiting",
            statusClosed: "Closed",
            btnAdd: "Open Ticket",
            it: "Technical support",
            commercial: "Commercial",
            questions: "Doubts",
            others: "Other matters",
            access: "Access",
            departments: "Departments",
            priority: "Priority",
            required: {
              subject: "The subject of the ticket is required.",
              department: "Please select a department.",
              message: "The message is required.",
              note: {
                id: "Ticket ID is required.",
                content: "Enter a message.",
                file: "File is required."
              }
            },
            error: {
              createTicket: "Oops! Error opening a new ticket.",
              deleteTicket: "Oops! Error deleting ticket.",
              updateTicket: "Oops! Error updating ticket.",
              createNote: "Oops! Error sending message.",
              uploading: "Oops! Error uploading file."
            },
            success: {
              createTicket: "Ticket successfully opened.",
              deleteTicket: "Ticket successfully deleted.",
              updateTicket: "Ticket successfully updated.",
              createNote: "Message sent successfully.",
              uploading: "File uploaded successfully."
            }
          },
          modalAdd: {
            title: "Open New Ticket",
            subject: "Subject",
            department: "Department",
            priority: "Priority",
            status: "Status",
            btnAdd: "Open Ticket",
            createdAt: "Created at",
            actions: "Actions",
            update: "Update Ticket",
            btnSave: "Save",
            btnDel: "Del"
          }
        },
        internalHelpDesk: {
          title: "Chat",
          labels: {
            upload: "Upload File",
            send: "Send",
            message: "Type your message",
            sending: "Sending...",
            uploading: "Uploading...",
            download: "Download",
            detailsTicket: "Ticket Details",
            subject: "Subject",
            description: "Description",
            createdAt: "Created At",
            department: "Department",
            status: "Status",
            priority: "Priority"
          }
        },
        notFound: {
          title: "404 - Page Not Found",
          subtitle: `Oops! It looks like you've gotten lost on the way... But don't worry, 
          we're here to help you.`,
          btnHome: "Home Page"
        },
        dashboard: {
          alertToast:
            "Attention: Your bill is about to expire. Regularize your payment!",
          title: "Dashboard",
          totalContacts: "Total contacts",
          totalUsers: "Total users",
          totalProperties: "Total properties",
          last12Months: "Contacts from the last 12 months",
          addContacts: "Added Contacts",
          notNotifications: "No notifications to display",
          cancel: "Cancel",
          more: "Learn More",
          dialogPopup: {
            title: "Restricted Area",
            description:
              "To access this area, you need to upgrade your current plan. Unlock premium features and enjoy all the benefits.",
            back: "Go Back",
            upgrade: "Upgrade Now"
          },
          labels: {
            cpfOrCnpj: "Invalid CPF or CNPJ.",
            concludedNegotiations: "Concluded Negotiations",
            cardOne: "Total Conversations",
            cardTwo: "Active Tickets",
            cardThree: "Conversations Today",
            cardFour: "Completed Attendances",
            titleGraphicLine: "Attendances in the Last 12 Months",
            value: "Attendances",
            total: "Total conversations",
            titleSale: "Sales Last 12 Months",
            titleContacts: "Contacts Last 12 Months",
            totalContacts: "Total Contacts",
            totalValue: "Sale Value",
            totalCommission: "Total Commission",
            funnelNegotiation: "Sales Negotiation",
            calendarTitle: "Calendar",
            btnClear: "Clear",
            type: "Type",
            subtype: "SubType",
            dateStart: "Start Date",
            dateEnd: "End Date",
            filters: "Filters",
            interval: "To",
            search: "Search",
            period: "Select the Period"
          }
        },
        config: {
          title: "Settings",
          successEdit: "Settings saved successfully.",
          upload: "Upload Photo",
          uploadFavicon: "Upload Favicon",
          uploadLogo: "Upload Logo",
          uploadBackground: "Upload Image Background",
          errorEdit: "Error saving settings.",
          socialMedia: {
            title: "Social media",
            btn: "Edit"
          },
          address: {
            title: "Address",
            state: "State",
            city: "City",
            neighborhood: "Neighborhood",
            street: "Street",
            number: "Number"
          },
          contact: {
            title: "Contact",
            phone: "Phone"
          },
          about: {
            title: "About",
            desc: "Describe yourself or your company:",
            img: "Featured image",
            video: "Video"
          },
          whatsapp: {
            title: "Whatsapp",
            message: "Whatsapp Message",
            status: "Activate WhatsApp"
          },
          view: {
            title: "View",
            titleSite: "Title",
            cnpj: "Company Number",
            creci: "License"
          },
          scripts: {
            title: "Scripts"
          }
        },
        checkout: {
          title: "Checkout",
          titleError: "Checkout Error",
          titleSuccess: "Checkout Success",
          errorCredit: "Error processing payment by card.",
          successCredit: "Payment successfully completed.",
          errorCpf: "The CPF or CNPJ in your profile is invalid. Click here",
          steps: {
            user: "User",
            payment: "Payment"
          },
          oneStep: {
            title: "Personal Data",
            name: "Name",
            postalCode: "Postal Code",
            phone: "Phone",
            addressNumber: "Address Number"
          },
          twoStep: {
            credit: "Credit Card",
            pix: "PIX",
            methodTitle: "Payment Method",
            selectMethod: "Select the payment method",
            holderName: "Cardholder Name",
            number: "Card Number",
            expiryMonth: "Expiration Month",
            expiryYear: "Expiration Year",
            ccv: "CCV",
            titleQr: "QR Code for PIX Payment",
            loadQr: "Generating PIX...",
            installments: "Installments",
            expire: "Expires on",
            product: "Product",
            mode: "Mode",
            value: "Value",
            pixSuccess: "Pix confirmed successfully."
          },
          info: {
            title: "Cardholder Information"
          },
          navigation: {
            back: "Back",
            next: "Next",
            finish: "Finish",
            finishing: "Finalizing..."
          },
          labels: {
            name: "Name is required.",
            email: "Email must be valid.",
            cpfCnpj: "CPF/CNPJ is required.",
            postalCode: "Postal code is required.",
            phone: "Phone number is required.",
            addressNumber: "Address number is required.",
            creditCardHolderInfo: {
              name: "Cardholder name is required.",
              email: "Cardholder email must be valid.",
              cpfCnpj: "Cardholder CPF/CNPJ is required.",
              postalCode: "Cardholder postal code is required.",
              phone: "Cardholder phone number is required.",
              addressNumber: "Cardholder address number is required."
            },
            creditCard: {
              holderName: "Credit card holder name is required.",
              number: "Invalid card number! Must have at least 16 characters.",
              expiryMonth:
                "Invalid expiration month! Must have at least 2 characters.",
              expiryYear:
                "Invalid expiration year! Must have at least 4 characters.",
              ccv: "Invalid CCV! Must have at least 3 characters.",
              installments: "Number of installments is required."
            },
            error: {
              title: "There was a problem processing your payment.",
              description:
                "Please try again or select another payment method. If the error persists, contact our support team so we can assist you.",
              retry: "Try again"
            },
            success: {
              title: "Payment successfully completed.",
              description:
                "Your payment has been successfully confirmed! Now you can enjoy your purchase. Check the payment receipt below.",
              proof: "View receipt",
              link: "Return to the system"
            }
          }
        },
        myAccount: {
          title: "My Account",
          changePass: "Change Password",
          firstname: "First Name",
          lastname: "Last Name",
          phone: "Phone",
          changeCover: "Change Cover",
          license: "License",
          planActive: "Plan",
          maxProperties: "Property Limit",
          maxPhotos: "Photo Limit",
          value: "Value",
          updatePlan: "Change Plan",
          periodPlan: "Subscription Period",
          until: "Until",
          lifetime: "Lifetime",
          freePlan: "Free",
          cancelPlan:
            "Are you sure you want to cancel your plan? After the subscription period ends, your account will be downgraded to the Free plan.",
          confirmCancel: "Cancel Plan",
          update: "Update",
          modalTitle: "Change your password",
          modalBtn: "Save",
          password: "Password",
          password2: "Repeat the password",
          passError:
            "Password shorter than 6 characters or passwords do not match",
          passSuccess: "Password changed successfully",
          changeSuccess: "Updated successfully",
          changeError: "Failed, try again!",
          document: "Document",
          city: "City",
          state: "State",
          userData: "Personal Data",
          markWater: "Watermark",
          username: "Username",
          unlimited: "Unlimited",
          description: "Description",
          error: {
            username: "Oops! Error changing username.",
            cancel: "Oops! Error canceling the plan."
          },
          success: {
            username: "Username changed successfully.",
            cancel: "Plan successfully canceled."
          },
          labels: {
            errorUpdate: "Oops! Error updating image.",
            successUpdate: "Image changed successfully.",
            errorSelected: "No image selected."
          }
        },
        newPassWd: {
          title: "Recover Password",
          button: "Reset Password",
          password: "Password",
          password2: "Repeat password"
        }
      },
      system: "System",
      logout: "Logout",
      myAccount: "My Account",
      en: "English",
      pt: "Portuguese",
      planExpired:
        "Your plan has expired. Renew now to continue using our services.",
      lang: "Website language",
      notifications: "Notifications",
      settings: "Settings",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      popupInfo: {
        invoiceExpiredTitle: "Your plan has expired",
        invoiceExpiredSubtitle: "Renew now to continue using our services."
      },
      help: "Help",
      profile: "Profile",
      payments: "Payments",
      marketplace: "Marketplace",
      logoutSystem: "Exit the System",
      groups: {
        shortcuts: "Shortcuts",
        finance: "Finance",
        whatsappActivation: "Activate number",
        whatsappReview: "WhatsApp Review",
        settings: "Settings"
      },
      statesBusiness: {
        active: "LEADS",
        approved: "ACTIVE/APPROVED",
        contract: "CONTRACT SIGNED",
        closing: "CLOSING PROCESS"
      },
      alerts: {
        successCreate: "Successfully created",
        successEdit: "Successfully edited",
        successDelete: "Deleted",
        errorCreate: "Failure to create",
        errorEdit: "Failed to edit",
        errorDelete: "Failed to delete",
        suportError: "Sending failed, contact support"
      }
    }
  }
}

export { messages }
